export default {
  methods: {
    /**
     * Assigns a global panel to the named layout position on all eligible steps.
     * Eligible = step is in panel.globalVisibleOnSteps AND the step has that position enabled.
     * @param {Object} panel         - The panel object (must be a master panel)
     * @param {Array}  steps         - All steps of the form
     * @param {String} positionName  - The position name, e.g. "TopBar", "SidebarLeft"
     * @param {String} [skipUuid]    - Optional step uuid to skip (e.g. current step already handled)
     */
    applyPanelLayoutPositionToSteps(panel, steps, positionName, skipUuid = null) {
      if (!panel.isMaster || !panel.globalVisibleOnSteps) return;

      for (const step of steps) {
        if (skipUuid && step.uuid === skipUuid) continue;
        if (!panel.globalVisibleOnSteps.includes(step.uuid)) continue;
        if (!step.layout || !step.layout.positions) continue;

        const constant = Object.keys(step.layout.positions).find(k =>
          step.layout.positions[k] && step.layout.positions[k].name === positionName
        );
        if (!constant) continue;
        if (!step.layout.positions[constant].enabled) continue;

        // Clear any previous assignment of this panel in this step's layout
        Object.keys(step.layout.positions).forEach(k => {
          if (step.layout.positions[k] && step.layout.positions[k].panelId === panel.uuid) {
            this.$set(step.layout.positions[k], 'panelId', null);
          }
        });

        // Only assign if the position is unoccupied
        if (!step.layout.positions[constant].panelId) {
          this.$set(step.layout.positions[constant], 'panelId', panel.uuid);
        }
      }

      this.$store.dispatch('createNotification', { text: this.$t('vform.layoutPositionAppliedToAllSteps') });
    },
  },
};

